module.exports = __webpack_public_path__ + "static/media/logo.e6f5bd10.svg";